module.exports = __webpack_public_path__ + "static/media/building-night.8226db55.svg";